import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import Icon from "@/components/home/Icon";
import type { PATHS } from "@/components/home/Icon";

export type ContributeAction = "review" | "add-store" | "claim";

// Compact version of ContributeGrid's three cards — opened from the mobile
// header's «شارك معنا» button (shown on every page with the public Header).
const ACTIONS: Array<{
  ic: keyof typeof PATHS;
  h: string;
  p: string;
  action: ContributeAction;
}> = [
  {
    ic: "pencil",
    h: "قيّم متجر جربته",
    p: "رأيك بيوفّر على ناس تانية فلوس ووجع دماغ.",
    action: "review",
  },
  {
    ic: "store",
    h: "ضيف متجر مش لاقيه عندنا",
    p: "ابعتلنا اللينك واحنا هنكمّل الباقي.",
    action: "add-store",
  },
  {
    ic: "shield",
    h: "طالب بملكية متجرك",
    p: "رد على التقييمات واظهر كمالك مُتحقَّق.",
    action: "claim",
  },
];

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onAction: (action: ContributeAction) => void;
};

export default function ContributeModal({ isOpen, onClose, onAction }: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="sm:max-w-md" dir="rtl">
        <DialogHeader>
          <DialogTitle
            className="text-center text-xl font-bold font-arabic"
            style={{ color: "var(--ys-primary-hover)" }}
          >
            شارك معنا
          </DialogTitle>
          <p className="text-center text-sm text-muted-foreground font-arabic pt-1">
            ٣ طرق تساعد بيها الناس تشتري وهي مطمّنة
          </p>
        </DialogHeader>

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {ACTIONS.map((a) => (
            <button
              key={a.action}
              type="button"
              onClick={() => onAction(a.action)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                width: "100%",
                textAlign: "start",
                padding: "14px 16px",
                background: "var(--ys-paper)",
                border: "1px solid var(--ys-rule)",
                borderRadius: "var(--ys-r-md)",
                cursor: "pointer",
                fontFamily: "var(--ys-font)",
                transition: "border-color var(--ys-dur), background var(--ys-dur)",
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  width: 44,
                  height: 44,
                  flexShrink: 0,
                  borderRadius: "var(--ys-r-md)",
                  background: "var(--ys-primary-soft)",
                  color: "var(--ys-primary-hover)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon n={a.ic} s={22} aria-hidden="true" />
              </span>
              <span style={{ minWidth: 0 }}>
                <span
                  style={{
                    display: "block",
                    fontSize: 15,
                    fontWeight: 700,
                    color: "var(--ys-ink)",
                    lineHeight: 1.35,
                  }}
                >
                  {a.h}
                </span>
                <span
                  style={{
                    display: "block",
                    fontSize: 12,
                    color: "var(--ys-ink-3)",
                    marginTop: 2,
                    lineHeight: 1.5,
                  }}
                >
                  {a.p}
                </span>
              </span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
